<!-- <iframe *ngIf='pozo' [src]="src | safe: 'resourceUrl'" style='width: 99%; height: 80vh;'></iframe> -->
<div class="chrome-mode absolute inset-0 flex flex-col min-w-9 overflow-y-auto" cdkScrollable>
    <div class="w-full text-center">
        <button mat-icon-button (click)="closeMenu()" (keydown.escape)="closeMenu()" class="absolute left-0 hover:bg-red-300">
            <mat-icon class="text-red-500">close</mat-icon>
        </button>

        <span class="text-black dark:text-white font-bold text-3xl">Visualización Adjunto</span>
    </div>

    <object [data]="src | safe: 'resourceUrl'" type="application/pdf" width="100%" height="592px" class="mt-2 w-full h-full"></object>

</div>